import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  dashboard: {
    id: 'header.user.menu.dashboard',
    defaultMessage: 'Dashboard',
    description: 'Link to the learner dashboard.',
  },
  programs: {
    id: 'header.links.programs',
    defaultMessage: 'Programs',
    description: 'Link to the learner programs page.',
  },
  discoverNew: {
    id: 'header.links.content.search',
    defaultMessage: 'Discover New',
    description: 'Link to the course catalog.',
  },
});

export default messages;
